import TextBox from 'components/TextBox'
import { Field } from 'formik'
import { getSalesEventTypes } from 'store/SalesEventTypes/selectors'
import { map } from 'lodash'
import { useSelector } from 'react-redux'

const PriceLevelDetails = ({ id, showValidationErrors }) => {
  const salesEvents = useSelector((state) =>
    getSalesEventTypes(state)
  )
  return (
    <>
      <h3 id={id} className="header-title -more-space">
        Price
      </h3>
      <div className="text-field">
        <Field
          component={TextBox}
          label="Price"
          name="price"
          showValidationErrors={showValidationErrors}
        />
      </div>
      {map(salesEvents, (salesEvents) => (
        <div className="text-field" key={salesEvents.uuid}>
          <Field
            component={TextBox}
            label={salesEvents.name}
            name={salesEvents.name.toLowerCase()}
            showValidationErrors={showValidationErrors}
          />
        </div>
      ))}
    </>
  )
}

export default PriceLevelDetails
